require('../../modules/es.object.to-string');
require('../../modules/es.string.iterator');
require('../../modules/web.dom-collections.iterator');
require('../../modules/es.promise');
require('../../modules/es.promise.all-settled');
require('../../modules/es.promise.finally');
var path = require('../../internals/path');

module.exports = path.Promise;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/es/promise/index.js
// module id = 371
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35